import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Ticker from 'react-ticker';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';

import userActions from '../actions/user_actions';

import '../../src/index.css';


export class AnnouncementMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
      //this.calcSpeed(100);
  }

  convertUserToDisplayName = (userId) => {
    return this.props.memberIdMap[userId].firstName + " " + this.props.memberIdMap[userId].lastName;
  };

  calcSpeed = (speed) => {
    var spanSelector = document.querySelector('.marquee span');
    var spanLength = spanSelector.offsetWidth;
    var timeTaken = spanLength / speed;
    spanSelector.style.animationDuration = timeTaken + "s";
  };

  getAnimation = (lengthOfAnnouncement) => {
    var seconds = 15 + Math.floor(lengthOfAnnouncement/9);
    return 'marquee ' + seconds + 's linear infinite';
  }
  
    render() {
    return (
      <div style={{ backgroundColor: '#f5f5f5', height: '100%', width: '100%', overflowY: 'hidden' }}>
        <Grid container spacing={0} justifyContent="center" style={{ height: '100%', width: '100%'}}>
          <Grid item xs={12} style={{ backgroundColor: '#E16464', padding: '5px', height: '100%', width: '100%' }}>
            <Card style={{ height: '100%', padding: '5px', overflow: 'auto', backgroundColor: 'pink', paddingTop: '0px' }}>
              <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '19px', 'cursor': 'default' }}>
                Announcement from {this.convertUserToDisplayName(this.props.announcement.userId)}
              </Typography>
              <div style={{ margin: '0 auto', whiteSpace: 'nowrap', overflow: 'hidden' }}>
              {/*<div className="marquee" style={{ width: '100%', margin: '0 auto', whiteSpace: 'nowrap', overflow: 'hidden', bottom: '0px' }}>*/}
                <span style={{ display: 'inline-block', paddingLeft: '100%', animation: this.getAnimation(this.props.announcement.message.length) }}>
              {/*<span style={{ display: 'inline-block', paddingLeft: '100%', animation: 'marquee linear infinite', animationDelay: '5s', bottom: '0px' }}>*/}
                  <Typography align="left" style={{ padding: '11px', fontSize: '18px', 'cursor': 'default' }}>
                    {this.props.announcement.message}
                  </Typography>
                </span>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile,
    currentUser: state.currentUser,
    memberIdMap: state.memberIdMap,
    memberNameMap: state.memberNameMap,
  };
}

const mapDispatchToProps = dispatch => ({
  updateManageUser: user => dispatch(userActions['UPDATE_MANAGE_USER'](user)),
  createManageUser: user => dispatch(userActions['CREATE_MANAGE_USER'](user)),
  deleteManageUser: user => dispatch(userActions['DELETE_MANAGE_USER'](user))
})

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementMessage);


// WEBPACK FOOTER //
// ./src/components/AnnouncementMessage.js